import { CheckboxInput } from '@app/app/_components/Input/CheckboxInput';
import { Message } from '@app/app/_components/Message/Message';
import { Paragraph } from '@app/app/_components/Paragraph/Paragraph';
import { useTranslations } from 'next-intl';
import { ChangeEvent } from 'react';

interface Props {
    isMinor: boolean;
    isLegalHeirSelected: boolean;
    onLegalHeirChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export function LegalHeirSelector({ isMinor, isLegalHeirSelected, onLegalHeirChange }: Props) {
    const t = useTranslations();

    return (
        <div className="flex flex-col gap-6">
            {isMinor && (
                <Message className="md:flex-row md:items-start" variant="info">
                    <div className="flex flex-col gap-2">
                        <Paragraph isBold>{t('lifeInsurance.ifInsuredPersonIsUnder18')}</Paragraph>
                        <ul>
                            <li className="ml-5 list-disc">
                                <Paragraph size="small">
                                    {t('lifeInsurance.onlyLegalHeirsCanBeBeneficiaries')}
                                </Paragraph>
                            </li>
                            <li className="ml-5 list-disc">
                                <Paragraph size="small">{t('lifeInsurance.theRestrictionAppliesUntilAge18')}</Paragraph>
                            </li>
                        </ul>
                    </div>
                </Message>
            )}

            {!isMinor && isLegalHeirSelected && (
                <Message variant="info">{t('lifeInsurance.legalHeirsSelectedMessage')}</Message>
            )}

            <CheckboxInput
                name="isLegalHeir"
                label={t('lifeInsurance.insuredPersonsLegalHeirs')}
                checked={isLegalHeirSelected}
                onChange={isMinor ? undefined : onLegalHeirChange}
            />
        </div>
    );
}
